import type { useAudioContentQuery$data } from './__generated__/useAudioContentQuery.graphql.ts';
import { useAudioContentFragmentData } from './AudioContentProvider.tsx';
import { useAudioContentQuery } from './useAudioContentQuery.tsx';

export const useAudioContent = ({
	contentId,
}: {
	contentId: string;
}): { data: useAudioContentQuery$data | undefined } => {
	const fragmentData = useAudioContentFragmentData();
	const { data: queryData } = useAudioContentQuery({
		contentId,
		skip: Boolean(fragmentData),
	});

	return {
		data: fragmentData
			? ({
					singleContent: {
						...fragmentData,
						properties: fragmentData.audioProperties,
					},
				} as useAudioContentQuery$data)
			: queryData,
	};
};
